import React from 'react';
import { BODY, ink } from '../../primitives.js';

const h = React.createElement;

/**
 * Inline chip linking to a doc (¶ prefix).
 *
 * @param {object} p
 * @param {React.ReactNode} [p.children]
 * @param {string} [p.href]
 * @param {React.MouseEventHandler} [p.onClick]
 */
export function DocRef({ children, href, onClick }) {
  return h('a', { href: href || '#', onClick, style: { display: 'inline-flex', alignItems: 'center', gap: 6, padding: '3px 9px', border: ink(1.5), borderRadius: 7, background: 'var(--card)', fontFamily: BODY, fontSize: 11.5, fontWeight: 700, color: 'var(--tx)', textDecoration: 'none' }, className: 'gx-docref' }, h('span', { className: 'gx-pil', 'aria-hidden': true, style: { display: 'inline-block' } }, '¶'), children);
}
